import React from 'react'
import { Component } from 'react';
import DisclosureJsx from './disclosure.jsx'

export default class Disclosure extends Component{
    render(){
        return(
            <div>
                <DisclosureJsx />
            </div>
        )
    }
}